/**
 * Remembers what had focus as an overlay opens and gives it back on close.
 *
 * Radix's modal content returns focus to its own Trigger. The overlays here
 * are controlled from a button elsewhere on the page, so there is no Trigger
 * and Radix would leave focus on the body. The layout effect runs before
 * Radix moves focus into the content, so it sees the opener.
 */
import { useCallback, useLayoutEffect, useRef } from 'react';

/** Returns the handler for Radix's `onCloseAutoFocus`. */
export function useReturnFocus(open: boolean): (event: Event) => void {
  const opener = useRef<HTMLElement | null>(null);

  useLayoutEffect(() => {
    if (open) opener.current = document.activeElement as HTMLElement | null;
  }, [open]);

  return useCallback((event: Event) => {
    event.preventDefault();
    opener.current?.focus();
  }, []);
}
